export default __webpack_public_path__ + "static/media/Intuit-QB-Logo-Partner.0594af45.svg";